import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Bounty } from 'src/app/interfaces/Bounty';

@Component({
  selector: 'app-general-fields',
  templateUrl: './general-fields.component.html',
  styleUrls: ['./general-fields.component.scss'],
})
export class GeneralFieldsComponent implements OnInit, OnDestroy {
  @Input() parentForm: FormGroup;
  @Input() submitFailed: boolean;
  @Input() bounty?: Bounty;

  public hasCustomRule = false;
  public customRule: string;
  public reward: number;
  public isPool: boolean;

  public subscriptions = [];

  constructor() {}

  ngOnInit() {
    if (this.bounty) {
      this.hasCustomRule = !!this.bounty.custom_goal;
      this.customRule = this.bounty.custom_goal;
      this.reward = this.bounty.reward / 100;
    }
    const controls = {
      hasCustomRule: new FormControl(this.hasCustomRule),
      customRule: new FormControl(this.customRule),
      reward: new FormControl(this.reward, [
        Validators.required,
        Validators.min(1),
        Validators.max(1000),
      ]),
      isPool: new FormControl(this.isPool),
    };

    Object.keys(controls).forEach(name => {
      if (!this.parentForm.controls[name]) {
        this.parentForm.addControl(name, controls[name]);
      }
    });

    // When beatmap goals change, update validators
    const beatmapGoalsSub = this.parentForm.controls.hasCustomRule.valueChanges.subscribe(
      value => {
        this.setCustomRuleValidator(!!value);
      },
    );

    this.subscriptions = [beatmapGoalsSub];
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private setCustomRuleValidator(isActive: boolean) {
    if (isActive) {
      this.parentForm.controls.customRule.setValidators([
        Validators.minLength(3),
        Validators.maxLength(74),
        Validators.required,
      ]);
    } else {
      this.parentForm.controls.customRule.clearValidators();
    }

    this.parentForm.controls.customRule.updateValueAndValidity();
  }

  public hasError(controlKey: string) {
    const control = this.parentForm.get(controlKey);
    const touchedOrSubmitted = !control.pristine || this.submitFailed;

    return control.errors && touchedOrSubmitted;
  }

  public get canChangeReward() {
    return !this.bounty || this.bounty.payment_type !== 'pool';
  }
}
